import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import App from './App';

import { BrowserRouter} from "react-router-dom";

// import 'semantic-ui-css/semantic.min.css'
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min';

import { ToastContainer, toast } from 'react-toastify';

import { ConfirmContextProvider } from './store/ConfirmContextProvider';
import ConfirmDialog from './Utils/ConfirmDialog';

import ConfirmDialogProvider from "./providers/ConfirmDialog2";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <App />
    
    <BrowserRouter>
      <ToastContainer />
      
      {/* <App /> */}
      
      {/* <ConfirmDialogProvider>
      <App />
      </ConfirmDialogProvider> */}
      

      <ConfirmContextProvider>
        <App />
        <ConfirmDialog/>
      </ConfirmContextProvider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
